module.exports = __webpack_public_path__ + "static/img/Anle_Banner_springAndwinter.c32a2430.jpg";